(ns app.front.view.council-decision.list
  (:require [app.domain.attachment.file-formats :as file-formats]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.workspace.section :as ws-section]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-fx ::save-council-decision-data-success
  (fn [{:keys [db]} [_ council-decision-id status db-changes]]
    {:dispatch-n [[::entities/apply-changes status db-changes]
                  [:notifications/add
                   :toast
                   :success
                   :success
                   :council-decision/data-updated]]
     :db         (update db ::council-decisions dissoc council-decision-id)}))


(rf/reg-sub
  ::no-changes?
  (fn [db [_ council-decision-id]]
    (-> db
        (get-in [::council-decisions council-decision-id])
        empty?)))


(rf/reg-sub
  ::get-current-value-of-attr
  (fn [db [_ council-decision-id attr saved-value]]
    (if-let [key+new-value (some-> db
                                   (get-in [::council-decisions council-decision-id])
                                   (select-keys [attr])
                                   seq
                                   first)]
      (second key+new-value)
      saved-value)))


(rf/reg-event-fx
  ::save-council-decision-data
  (fn [{:keys [db]} [_ application council-decision-id]]
    (let [data (get-in db [::council-decisions council-decision-id])]
      {:dispatch [:app.front.process/signal
                  application
                  [:process.signal/save-council-decision-data {:council-decision-id   council-decision-id
                                                               :council-decision-data data}]
                  {:on-success [::save-council-decision-data-success council-decision-id]}]})))


(rf/reg-event-db
  ::update-council-decision-data
  (fn [db [_ council-decision-id attr saved-value new-value]]
    (let [path [::council-decisions council-decision-id attr]]
      (if (= saved-value new-value)
        (p/dissoc-in db path)
        (assoc-in db path new-value)))))


(rf/reg-event-fx
  ::delete-council-decision
  (fn [_ [_ application council-decision-id]]
    {:dispatch [:app.front.process/signal
                application
                [:process.signal/delete-council-decision {:council-decision-id council-decision-id}]
                {:notify {:success :council-decision/delete-success}}]}))


(defn upload-button [on-attach]
  [upload/upload-button
   "upload-council"
   {:attach-file-fn  on-attach
    :button-i18n-key :council-decision/upload-help
    :accept-types    file-formats/convertable-accept-value-for-input}])


(defn- add-council-decision-attachment [application file-id filename content-type md5]
  (>evt [:app.front.process/signal
         application
         [:process.signal/add-council-decision-file
          {:file-id           file-id
           :file/filename     filename
           :file/content-type content-type
           :file/category     :file.category/council-decision
           :file/md5          md5}]
         {:notify {:success :council-decision/upload-success}}]))


(defn list-view [{:keys [application tr workspace] :as state}]
  (let [add-permitted?    (<sub [:app.front.process/app-signal-permitted?
                                 [:process.signal/add-council-decision-file]])
        delete-permitted? (<sub [:app.front.process/app-signal-permitted?
                                 [:process.signal/delete-council-decision]])
        save-permitted?   (<sub [:app.front.process/app-signal-permitted?
                                 [:process.signal/save-council-decision-data]])
        council-decisions (<sub [::entities/entities {:entity/type   :entity.type/council-decision
                                                      :entity/parent (:db/id application)}])
        display-kind?     (or (->> council-decisions
                                   (some #(-> % :council-decision/kind (= :council-decision.kind/upper-tier))))
                              (-> workspace :workspace/approval-authority some?))]
    (when (or add-permitted?
              (seq council-decisions))
      [ws-section/section
       application
       :council-decision/council-decision
       state
       :council-decision/council-decision
       true
       (when (seq council-decisions)
         #_{:clj-kondo/ignore [:deprecated-var]}
         [ui-table/responsive-table {:tr          tr
                                     :class       "-ml-4 lg:ml-0 mb-4"
                                     :expandable? false}
          (->> [{:title (tr [:council-decision/filename])}
                {:title (tr [:council-decision/attachment-description])}
                {:title (tr [:council-decision/added])}
                (when display-kind?
                  {:title (tr [:council-decision/kind])})
                {:title (tr [:council-decision/decision-date])}
                (when (or save-permitted? delete-permitted?) {:title ""})]
               (remove nil?))
          (futil/for-all [council-decision council-decisions]
            (r/with-let [*editing (r/atom false)]
              (let [file                (-> (eu/descendants :entity.type/file council-decision)
                                            (p/find-first {:file/category :file.category/council-decision}))
                    council-decision-id (:db/id council-decision)
                    saved-description   (or (:council-decision/attachment-description council-decision) "")
                    saved-decision-date (:council-decision/decision-date council-decision)]
                {:key  (:db/id council-decision)
                 :cols [{:opts    {:class "bold overflow-hidden"}
                         :content (when file
                                    [file-download/download-workspace-file-link file
                                     {:class "break-words"
                                      :text  (:file/filename file)}])}
                        {:content (if @*editing
                                    [:div {:style {:max-width "95%"}}
                                     [ui/text-input {:id          (str council-decision-id "-description")
                                                     :value       (<sub [::get-current-value-of-attr
                                                                         council-decision-id
                                                                         :council-decision/attachment-description
                                                                         saved-description])
                                                     :label-text  (tr [:council-decision/attachment-description])
                                                     :placeholder (tr [:council-decision/attachment-description-placeholder])
                                                     :hide-label  true
                                                     :on-change   #(>evt [::update-council-decision-data
                                                                          council-decision-id
                                                                          :council-decision/attachment-description
                                                                          saved-description
                                                                          (futil/tval %)])}]]
                                    [:div (if (str/blank? saved-description)
                                            (tr [:council-decision/no-attachment-description])
                                            saved-description)])}
                        {:content [:<>
                                   [:div ((<sub [::date-util/date-time-fn]) (:entity/created council-decision))]
                                   [:div (tr [:council-decision/uploaded-by]
                                             [(user-model/full-name (:entity/creator council-decision))])]]}
                        (when display-kind?
                          {:content [:div
                                     (if @*editing
                                       [ui-select/select {:id           (str council-decision-id "-kind")
                                                          :values       [:council-decision.kind/lower-tier
                                                                         :council-decision.kind/upper-tier]
                                                          :val->str     (comp tr vector)
                                                          :value        (<sub [::get-current-value-of-attr
                                                                               council-decision-id
                                                                               :council-decision/kind
                                                                               (:council-decision/kind council-decision)])
                                                          :allow-empty? false
                                                          :on-change    #(>evt [::update-council-decision-data
                                                                                council-decision-id
                                                                                :council-decision/kind
                                                                                (:council-decision/kind council-decision)
                                                                                %])}]
                                       (-> council-decision :council-decision/kind vector tr))]})
                        {:content (if @*editing
                                    [:<>
                                     [ui/date-picker {:value    saved-decision-date
                                                      :width    "100%"
                                                      :callback #(>evt [::update-council-decision-data
                                                                        council-decision-id
                                                                        :council-decision/decision-date
                                                                        saved-decision-date
                                                                        %])}]]
                                    [:<>
                                     ((<sub [::date-util/date-fn]) (:council-decision/decision-date council-decision))])}
                        (when (or save-permitted? delete-permitted?)
                          {:opts    {:class "text-right"}
                           :content [:<>
                                     (if @*editing
                                       [:<>
                                        (cc/button {:kind       :ghost
                                                    :class-name "ml-2"
                                                    :on-click   #(reset! *editing false)}
                                                   (tr [:cancel]))
                                        (cc/button {:kind       :primary
                                                    :class-name "ml-2 px-3"
                                                    :disabled   (<sub [::no-changes? council-decision-id])
                                                    :on-click   #(do
                                                                   (reset! *editing false)
                                                                   (>evt [::save-council-decision-data application (:db/id council-decision)]))}
                                                   (tr [:confirm]))]

                                       [:<>
                                        (when save-permitted?
                                          (cc/button {:kind       :ghost
                                                      :class-name "ml-2"
                                                      :on-click   #(reset! *editing true)}
                                                     (tr [:council-decision/change])))
                                        (when delete-permitted?
                                          [ui/modal-confirmation-button {:tr                  tr
                                                                         :id                  "delete-council-decision"
                                                                         :modal-class         "text-left"
                                                                         :modal-title         (tr [:council-decision/delete-council-decision])
                                                                         :trigger-button-opts {:icon i/trash
                                                                                               :kind :ghost}
                                                                         :trigger-button-text (tr [:delete])
                                                                         :on-yes-click        #(>evt [::delete-council-decision application council-decision-id])}
                                           (tr [:council-decision/delete-confirmation])])])]})]})))])
       (when add-permitted?
         [:div.bx--row
          [:div.bx--col-xs-12
           [upload-button (partial add-council-decision-attachment application)]]])])))
